import moment from "moment";
import store from "../store/store";
import { getData } from "@services/apiConfig";
import { messagelibrary, logout as logoutapi } from "@constants/endpoints";
// import { useDispatch } from "react-redux";
import { showLoader } from "@store/actions/loaderAction";
// import { persistor } from "@store/store"; // Make sure to import your store
import { resetState } from "@store/actions/basicConifgAction";

export function exampleFunc(value) {
  const status = value;
  return status;
}

const htmlTagRegex = /<\/?[^>]+(>|$)/g;
const jsTagRegex = /<script\b[^>]*>(.*?)<\/script>/gi;

export const validateNoHtmlJsTags = (_, value) => {
  if (htmlTagRegex.test(value) || jsTagRegex.test(value)) {
    return Promise.reject(
      new Error("HTML or JavaScript tags are not allowed!")
    );
  }
  return Promise.resolve();
};

const htmlTagRegexCQ = /<\/?[a-z]+\s*[^>]*>/i; ///<\/?[a-z][\s\S]*>/i;
const jsTagRegexCQ = /<script[\s\S]*?>[\s\S]*?<\/script>/i;

export const validateCustomQuery = (_, value) => {
  if (htmlTagRegexCQ.test(value) || jsTagRegexCQ.test(value)) {
    return Promise.reject(
      new Error("HTML or JavaScript tags are not allowed!")
    );
  }
  return Promise.resolve();
};


export function parseQuery(queryString) {
  const pairs = (
    queryString[0] === "?" ? queryString.substr(1) : queryString
  ).split("&");
  return pairs.reduce((acc, curr) => {
    const [key, value] = curr.split("=");
    acc[decodeURIComponent(key)] = decodeURIComponent(value || "");
    return acc;
  }, {});
}

export function xmltoJson(xmlString) {
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xmlString, "text/xml");

  function xmlToJson(xml) {
    let obj = {};

    if (xml.nodeType === 1) {
      // Element
      // Process attributes
      if (xml.attributes.length > 0) {
        obj["@attributes"] = {};
        for (let j = 0; j < xml.attributes.length; j++) {
          const attribute = xml.attributes.item(j);
          obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
        }
      }

      // Process children
      if (xml.hasChildNodes()) {
        let hasTextNode = false;
        for (let i = 0; i < xml.childNodes.length; i++) {
          const item = xml.childNodes.item(i);
          const nodeName = item.nodeName;

          if (item.nodeType === 3 && item.nodeValue.trim()) {
            // Text node
            obj["#text"] = item.nodeValue.trim();
            hasTextNode = true;
          } else if (item.nodeType === 1) {
            // Element node
            const childJson = xmlToJson(item);

            if (typeof obj[nodeName] === "undefined") {
              obj[nodeName] = childJson;
            } else {
              if (typeof obj[nodeName].push === "undefined") {
                const old = obj[nodeName];
                obj[nodeName] = [];
                obj[nodeName].push(old);
              }
              obj[nodeName].push(childJson);
            }
          }
        }

        // If there is only text content and no child elements
        if (hasTextNode && Object.keys(obj).length === 1) {
          obj = obj["#text"];
        }
      }
    } else if (xml.nodeType === 3) {
      // Text node
      obj = xml.nodeValue.trim();
    }

    return obj;
  }

  return xmlToJson(xmlDoc.documentElement);
}

export function fileDownload(foldername, filename) {
  let baseUrl = process.env.REACT_APP_PUBLIC_URL;

  if (process.env.NODE_ENV === "development") {
    baseUrl = "https://nigeria.1dataconnect.com";
  }

  const staticPath = "public_html/Files";

  const fileUrl = `${baseUrl}/${staticPath}/${foldername}/${filename}`;
  initiateDownload(fileUrl);
}

function initiateDownload(filepath) {
  if (!filepath) {
    console.error("Invalid filepath");
    return;
  }

  const link = document.createElement("a");
  link.href = filepath;
  link.download = filepath.split("/").pop();
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function dataFormat(date) {
  return moment(date).format("lll");
}

export const generateData = (data, uDetails) => {
  return data.map((k, i) => {
    return {
      key: i + 1,
      label: k.label,
      children: k.static ? k.key : uDetails[k.key],
    };
  });
};

export const randomNineDigitNumber = (length) => {
  length = length ?? 10;
  let result = "";
  for (let i = 0; i < length; i++) {
    result += Math.floor(Math.random() * length);
  }
  return parseInt(result);
};

export const validateSpaces = (_, value) => {
  // Regular expression to match leading/trailing spaces or all spaces
  const spaceRegex = /^\s+|\s+$|\s+(?=\s)/g;
  if (value && value.match(spaceRegex)) {
    return Promise.reject(
      "Input should not contain leading/trailing spaces or consist only of spaces."
    );
  }
  return Promise.resolve();
};

//This is React component
export const FetchMessagesFromLibrary = async ({
  msgcode,
  lang = "en",
  dynamicValues = [],
}) => {
  let specificMessage = "No Error Message Configured in Message Library";
  const state = store.getState();
  let messagesList = state.basicConfigReducer.messageLibrary;

  if (messagesList.length === 0) {
    const payload = {
      url: messagelibrary,
    };
    messagesList = await getData(payload);
  }

  // let message = messagesList.find((message) => message.code === msgcode);
  let message = messagesList.find((message) => message.code == msgcode);
  if (message && Object.keys(message).length > 0) {
    specificMessage = message?.message?.[lang] || "";
  }

  if (dynamicValues.length) {
    dynamicValues.forEach((d) => {
      specificMessage = specificMessage.replace(`{${d.key}}`, d.value);
    });
  }
  return specificMessage;
};

//logout utility to clear all sessions and cookies
export const logout = async () => {
  const state = store.getState();
  const dispatch = store.dispatch; // Get the dispatch function from the store
  // console.log("state", state);
  // console.log("email", state.basicConfigReducer?.console?.email);
  try {
    const payload = {
      url: logoutapi,
      headers: {
        "auth-username": state.basicConfigReducer?.console?.email || null,
      },
    };
    dispatch(showLoader(true));
    const res = await getData(payload);
    dispatch(showLoader(false));

    // Clear localStorage
    localStorage.clear();
    dispatch(resetState());
    // Clear sessionStorage
    sessionStorage.clear();
    // Clear cookies
    document.cookie.split(";").forEach((cookie) => {
      document.cookie = cookie
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    // persistor.purge();
    if (process.env.NODE_ENV === "development") {
      window.location.href = "http://localhost:3000/console/login";
    } else {
      window.location.href = window.location.origin + "/console/login";
    }
  } catch (err) {
    dispatch(showLoader(false));
    console.log("error", err);
  }
};
